import { writable, derived, get } from "svelte/store";
import en from "../i18n/en.json";
import fr from "../i18n/fr.json";
import es from "../i18n/es.json";
import pt from "../i18n/pt.json";

const STORAGE_KEY = "photron_lang";
const SUPPORTED = ["en", "fr", "es", "pt"];

function getStoredLocale() {
  if (typeof localStorage === "undefined") return "en";
  const stored = (localStorage.getItem(STORAGE_KEY) || "en").trim().toLowerCase();
  return SUPPORTED.includes(stored) ? stored : "en";
}

const messages = { en, fr, es, pt };

function resolve(obj, key) {
  if (!key || typeof key !== "string") return key;
  const value = key.split(".").reduce((o, k) => (o != null ? o[k] : undefined), obj);
  return value != null && typeof value === "string" ? value : key;
}

const initial = getStoredLocale();
if (typeof document !== "undefined") document.documentElement.lang = initial;
export const locale = writable(initial);

export function setLocale(code) {
  const next = SUPPORTED.includes(code) ? code : "en";
  try { localStorage.setItem(STORAGE_KEY, next); } catch (_) {}
  if (typeof document !== "undefined") document.documentElement.lang = next;
  locale.set(next);
}

export function getLocale() { return get(locale); }

export const t = derived(locale, (l) => {
  const dict = messages[l] || messages.en;
  return (key, params) => {
    let s = resolve(dict, key);
    if (params && typeof s === "string") {
      Object.entries(params).forEach(([k, v]) => {
        s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v ?? ""));
      });
    }
    return s;
  };
});

export function translate(key, params) {
  const l = get(locale);
  const dict = messages[l] || messages.en;
  let s = resolve(dict, key);
  if (params && typeof s === "string") {
    Object.entries(params).forEach(([k, v]) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v ?? ""));
    });
  }
  return s;
}

export { SUPPORTED };
